import { useState, useEffect } from 'react';
import fetchAPI from 'app/helpers/fetch';
import type { PlayMode } from 'app/CasinoGames/types';
import { State, PENDING, REJECTED, FULFILLED } from 'admin-mojo/helpers/StateNotification';
import type { LauncherProps, Launcher, LaunchParams } from './types';

const useLauncher = (props: LauncherProps): Launcher => {
  const { playerPresent, game } = props;

  const [state, setState] = useState<State>({ status: PENDING });
  const [launchParams, setLaunchParams] = useState<LaunchParams>();
  const [playMode, setPlayMode] = useState<PlayMode>(props.playMode);

  const load = (mode: PlayMode) => {
    setState({ status: PENDING });

    fetchAPI(`/casino_game_launch/${game.id}/${mode}.json`, { method: 'GET', body: null })
      .then((data) => {
        setLaunchParams(data);
        setState({ status: FULFILLED });
      })
      .catch((v) => {
        setState({ status: REJECTED, error: v });
      });
  };

  useEffect(() => {
    load(playMode);
  }, [playMode]);

  useEffect(() => {
    const onPlayngoReloadRequest = (e: MessageEvent<{ message: string; playForReal?: true }>) => {
      if (e.data.message !== 'reloadGameModal') return;
      if (e.data.playForReal) {
        if (!playerPresent) {
          window.location.assign('/login');
          return;
        }
        setPlayMode('real');
      } else {
        load(playMode);
      }
    };

    window.addEventListener('message', onPlayngoReloadRequest);

    return () => window.removeEventListener('message', onPlayngoReloadRequest);
  }, []);

  const isLoaded = state.status === FULFILLED && launchParams;

  const launchUrl = isLoaded ? launchParams.launch_url : null;

  const hasLaunchScript = isLoaded ? launchParams.has_launch_script : null;

  const jurisdiction = isLoaded ? launchParams.jurisdiction : null;

  const limits = isLoaded ? launchParams.limits : null;

  return {
    state,
    launchUrl,
    hasLaunchScript,
    playMode,
    jurisdiction,
    limits,
  };
};

export default useLauncher;
